import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Eye, Mail } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";

function replaceVars(text, row) {
  let result = text;
  for (const [key, value] of Object.entries(row)) {
    result = result.replaceAll(`{${key}}`, String(value ?? ""));
  }
  return result;
}

export function EmailPreview({ subject, body, firstRow, senderEmail }) {
  if (!firstRow) return null;

  const previewSubject = replaceVars(subject, firstRow);
  const previewBody = replaceVars(body, firstRow);

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button
          variant="outline"
          className="gap-2 rounded-full hover:scale-105 active:scale-95 transition-transform"
          data-testid="email-preview-button"
        >
          <Eye className="w-4 h-4" />
          Aperçu
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[600px]" data-testid="email-preview-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Mail className="w-5 h-5 text-primary" />
            Aperçu de l'email
          </DialogTitle>
          <DialogDescription>
            Rendu avec les données de la 1ère ligne
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 mt-2">
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <Badge variant="secondary" className="text-xs">De</Badge>
              <span className="text-sm font-mono text-zinc-600" data-testid="preview-from">
                {senderEmail || "non configuré"}
              </span>
            </div>
            <div className="flex items-center gap-2">
              <Badge variant="secondary" className="text-xs">À</Badge>
              <span className="text-sm font-mono text-zinc-600" data-testid="preview-to">
                {firstRow.email || firstRow.Email || "—"}
              </span>
            </div>
          </div>

          <Separator />

          <div>
            <p className="text-xs font-bold uppercase tracking-wider text-zinc-400 mb-1">Objet</p>
            <p className="text-base font-medium text-zinc-900" data-testid="preview-subject">
              {previewSubject || "(vide)"}
            </p>
          </div>

          <Separator />

          <div>
            <p className="text-xs font-bold uppercase tracking-wider text-zinc-400 mb-2">Corps</p>
            <div
              className="p-4 bg-zinc-50 rounded-lg border border-zinc-100 text-sm text-zinc-700 leading-relaxed min-h-[120px] [&_a]:text-primary [&_a]:underline"
              data-testid="preview-body"
              dangerouslySetInnerHTML={{ __html: previewBody || "<em>(vide)</em>" }}
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
